// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
// SPREAD INDICATOR
export const TerceraChartSpreadType =
{
    Area: 0,
    Lines: 1,
    LinesWithPrices: 2,
    None: 3
};
Object.freeze(TerceraChartSpreadType);